import { ChevronRight } from "@material-ui/icons";
import React from "react";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../../reducers";
import { useTranslation } from "react-i18next";
import { newVenueForm } from "../../../formSchemas/newVenue.form";
import EColourPanel from "../../../interfaces/EColourPanel";
import { IDialogChildComponent } from "../../../reducers/dialog";
import DynamicForms from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import { setVenueData } from "./state/newVenue.action";
import { useChangedDialog } from "../../../hooks/useChangedDialog";
import { handleIntegrationMetaData } from "../forms/VenueDetailsForm";
import hostClient from "../../../yoello-lib/modules/host/HostClient";
import { hosts } from "../../../yoello-lib/modules/host/Hosts";


interface INewVenueData {
    venue_name?: string;
    venue_location?: {
        value: any;
        name: string;
    };
    onboarding_source?: string;
    integration_object_id?:string;
    metadata?:Object;
};

interface INewVenueForm extends IDialogChildComponent {
    dispatch: any;
    venueData?: INewVenueData;
    callLeads: (data: INewVenueData) => Promise<void>;
    host?:string
}



export function NewVenueForm({ onClose, dispatch, venueData, callLeads,host }: INewVenueForm) {
    const { t } = useTranslation();
    const merchant = useSelector((state: IReduxAppState) => state.merchant)
    const { hasFormChanged } = useChangedDialog();
    function handleSubmit(data: INewVenueData) {
        const apiData = handleIntegrationMetaData(data,host ?? "YOELLO")
        callLeads({ ...apiData, onboarding_source: merchant.onboarding_source });
        dispatch(setVenueData({ venueDetails: data, onboarding_source: merchant.onboarding_source }))
    }
    return <DynamicForms
        formKeyName={"new-venue-form"}
        formRows={newVenueForm(merchant.onboarding_source, t, hostClient.host === hosts.bna)}
        onHandleSubmit={handleSubmit}
        formData={venueData}
        isDialog={true}
        hasDataChanged={hasFormChanged}
        formButtons={{
            leftButton: {
                label: t('misc.cancel'), type: "button", onClick: onClose,
                color: EColourPanel.DEFAULT
            },
            rightButton: {
                type: 'submit', label: t('signup.newVenue.buttonAdd'), endIcon: <ChevronRight />,
                color: EColourPanel.PRIMARY
            }
        }
        }
    />
}